import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../lib";
class ApiEpNotificationReportToken {
}
ApiEpNotificationReportToken.expand = ({ token }) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/notification/report/email/${token}`,
    method: "GET",
});
ApiEpNotificationReportToken.unsubscribe = ({ token }) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/notification/report/email/${token}`,
    method: "POST",
});
class ApiEpNotificationSettings {
}
/**
 * Used to get Notification Settings
 */
ApiEpNotificationSettings.retrieve = () => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/notification/settings`,
    method: "GET",
});
/**
 * Used to update Notification Settings
 */
ApiEpNotificationSettings.update = ({ settings, }) => apiRequest({
    body: settings,
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/notification/settings`,
    method: "PUT",
});
class ApiEpNotificationSubscribe {
}
/**
 * Used to get subscribe
 */
ApiEpNotificationSubscribe.retrieve = () => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/notification/subscribe`,
    method: "GET",
});
/**
 * Used to unsubscribe via medium and external_id
 */
ApiEpNotificationSubscribe.unsubscribe = ({ medium, external_id, }) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/notification/unsubscribe/${medium}:${external_id}`,
    method: "POST",
});
class ApiEpNotificationSubscriptionToken {
}
ApiEpNotificationSubscriptionToken.expand = ({ token }) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/notification/unsubscribe/${token}`,
    method: "GET",
});
ApiEpNotificationSubscriptionToken.unsubscribe = ({ token }) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/notification/unsubscribe/${token}`,
    method: "POST",
});
export class ApiEpNotification {
}
ApiEpNotification.ReportToken = ApiEpNotificationReportToken;
ApiEpNotification.Settings = ApiEpNotificationSettings;
ApiEpNotification.Subscribe = ApiEpNotificationSubscribe;
ApiEpNotification.SubscriptionToken = ApiEpNotificationSubscriptionToken;
/**
 * Used to delete Notification by id
 */
ApiEpNotification.destroy = ({ id, }) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/notification/notification/${id}`,
    method: "DELETE",
});
/**
 * Used to get Notification by id
 */
ApiEpNotification.retrieve = ({ id, }) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/notification/notification/${id}`,
    method: "GET",
});
/**
 * Used to get Notification list
 */
ApiEpNotification.list = () => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/notification/notification/`,
    method: "GET",
});
//# sourceMappingURL=notification.js.map